// extracted by mini-css-extract-plugin
export default {"container":"XB-z","vocBtn":"YB-z","disabled":"ZB-z"};